module.exports = __webpack_public_path__ + "img/public_resources_magnify_white.c2421989.svg";